// extracted by mini-css-extract-plugin
module.exports = {"metadata":"AA0tLyulHv5Js5ZsZqYr","daterange":"k_XEMZVR420tKaiIikuJ"};